import { useState } from 'react';

export default function WhatsAppButton() {
  const [showTooltip, setShowTooltip] = useState(false);

  const handleWhatsAppClick = () => {
    const message = encodeURIComponent('Hola, quiero cotizar productos de madera con Aserradero Santa Rosa.');
    window.open(`https://wa.me/56981372039?text=${message}`, '_blank');
  };

  return (
    <div className="fixed bottom-6 right-6 z-50">
      <div className="relative">
        {showTooltip && (
          <div className="absolute bottom-full right-0 mb-2 bg-[#2C2416] text-white px-4 py-2 rounded-lg text-sm font-semibold whitespace-nowrap shadow-lg">
            ¡Cotiza aquí!
            <div className="absolute top-full right-6 w-0 h-0 border-l-8 border-r-8 border-t-8 border-l-transparent border-r-transparent border-t-[#2C2416]"></div>
          </div>
        )}
        
        <button
          onClick={handleWhatsAppClick}
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
          className="w-16 h-16 bg-[#25D366] rounded-full flex items-center justify-center shadow-2xl hover:scale-110 transition-transform duration-300 animate-bounce cursor-pointer"
          aria-label="Contactar por WhatsApp"
        >
          <i className="ri-whatsapp-fill text-4xl text-white"></i>
        </button>
      </div>
    </div>
  );
}
